<template>
	<div :class="`relative ${full ? 'grow' : ''} max-w-full flex items-center`">
		<div class="absolute px-2 py-1 flex items-center">
			<i :class="iconClass"/>
		</div>
		<GenericInput type="text" :maxlength="maxlength" :value="modelValue" class="!pl-7 !pr-2 !py-1 max-w-full" :full="full" @update:value="updateValue"/>
	</div>
</template>
<script setup lang="ts">
import {defineEmits, defineProps} from 'vue'
import GenericInput from '@/Components/UI/Inputs/GenericInput.vue'

defineProps<{
	iconClass:string,
	modelValue:string|null,
	maxlength?:number,
	full?:boolean,
}>()

const emit = defineEmits([
	'update:modelValue',
])

function updateValue(newValue:string):void{
	emit('update:modelValue', newValue)
}
</script>
